<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="sectionHeader">
      <div class="driver">
        <div class="title">
          <div class="label">
            {{'DRIVERS.myDrivers' | translate}}
          </div>
          <div class="help" (click)="MultipleVideoLink()">
            <!-- <app-help [helpData]="helpData"></app-help> -->
            <img src="assets/helpicon.svg" style="width: 17px;margin-top: 3px;" alt="">
          </div>
        </div>

      </div>
      <!-- <div class="addDriver mat-elevation-z4" (click)="openMapView();">
                <span class="text">{{'DRIVERS.mapView' | translate}}</span>
            </div> -->
      <div class="addDriver mat-elevation-z4" (click)="openBulkUpload();">
        <span class="text">{{'DRIVERS.bulkDriver' | translate}}</span>
      </div>
      <div class="addDriver mat-elevation-z4" (click)="openAddDriver();">
        <span class="text">{{'DRIVERS.addDriver' | translate}}</span>
      </div>
      <!-- <div class="addDriver mat-elevation-z4" (click)="openDriverMapView();">
              <span class="text">{{'DRIVERS.driver_map_view' | translate}}</span>
            </div> -->
      <div class="addDriver mat-elevation-z4" style="width: 140px;" routerLink="/attendance-list">
        <span class="text">{{'DRIVERS.attendance_salary' | translate}}</span>
      </div>
      <div class="addDriver mat-elevation-z4" *ngIf="showButtons" (click)="smartphoneDialog();">
        <span class="text">{{'DRIVERS.smartphone' | translate}}</span>
      </div>
    </div>

    <div class="filter">
      <div class="container">
        <div class="search">
          <div class="inputSearch">
            <input class="inputSelect" type="input" [placeholder]="'DRIVERS.driverName' | translate"
              [(ngModel)]="filters.name" (keyup)="searchFilter(filters.name, 'name')">
            <i class="material-icons clearIcon" *ngIf="filters.name" (click)="filters.name = ''; clearFilter('name');">
              clear </i>
          </div>
        </div>
        <div class="search">
          <div class="inputSearch">
            <input class="inputSelect" type="input" [placeholder]="'DRIVERS.mobileNumber' | translate"
              [(ngModel)]="filters.mobile" (keyup)="searchFilter(filters.mobile, 'mobile')">
            <i class="material-icons clearIcon" *ngIf="filters.mobile"
              (click)="filters.mobile = ''; clearFilter('mobile');"> clear </i>
          </div>
        </div>
        <div class="search">
          <div class="inputSearch">
            <input class="inputSelect" type="text" autocomplete="off" name="licenceNum" id="licenceNum"
              [placeholder]="'DRIVERS.licence_number' | translate" [(ngModel)]="filters.licence"
              (keyup)="searchFilter(filters.licence, 'licence');">
            <i class="material-icons clearIcon" *ngIf="filters.licence"
              (click)="filters.licence = ''; clearFilter('licence');"> clear </i>
          </div>
        </div>
        <div class="search">
          <div class="inputSearch">
            <div class="inputSelect">
              <mat-select [placeholder]="'DRIVERS.driverType' | translate" [(ngModel)]="filters.driver_type">
                <mat-option *ngFor="let track of driverTypes" (onSelectionChange)="selectDriverType(track, $event)"
                  [value]="track.name">
                  {{track.name}}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table">
      <table mat-table *ngIf="driversList && driversList.filteredData.length; else noDrivers"
        [dataSource]="driversList.filteredData">

        <ng-container matColumnDef="selected">
          <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;">
            {{'DRIVERS.select' | translate}}
          </th>
          <td mat-cell *matCellDef="let element" style="padding-left: 2px;">
            <mat-checkbox (change)="selectDriver($event, element)" [(ngModel)]="element.selected"></mat-checkbox>
          </td>
        </ng-container>
        <!-- <ng-container matColumnDef="slno">
                <th mat-header-cell *matHeaderCellDef>
                  Sl No.
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element.driverName}}
                </td>
            </ng-container> -->
        <ng-container matColumnDef="driverName">
          <th mat-header-cell *matHeaderCellDef>
            <!-- <div class="input">

                        </div> -->
            <div class="value">
              {{'DRIVERS.driverName' | translate}}
            </div>
            <div class="value">
              {{'DRIVERS.on_off_duty' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="value">
              <img src="assets/atach-driver.svg" alt="" *ngIf="element.attached" style="width: 20px;"
                title="Driver is attahced to vehicle">
              {{element.driverName}}
              <!-- <i style="cursor: pointer ;font-size:15px;text-align:center" *ngIf="element.currentlocation.length" class="material-icons" (click)="openMap(element);" title="Driver Location">
                          room
                          </i> -->
            </div>
            <div class="value">
              <span
                [ngClass]="{'on-duty': element.trip_status == 'On Duty','off-duty': element.trip_status == 'Off Duty'}">
                {{element.trip_status}}
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="app_status">
          <th mat-header-cell *matHeaderCellDef>
            <!-- <div class="input">

                      </div> -->
            <div class="value">
              {{'DRIVERS.online_offline' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <span [ngClass]="{'online':element.status == 'Online','offline':element.status == 'Offline'}">
              {{element.status}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="driverMobile">
          <th mat-header-cell *matHeaderCellDef>
            <div class="value">
              {{'DRIVERS.mobileNumber' | translate}}
            </div>
            <div class="value">
              {{'DRIVERS.app_version' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="value">
              {{element.driverMobile}}
            </div>
            <div *ngIf="element.SecondaryMobile"><span
                title="Secondary Mobile Number">{{element.SecondaryMobile}}</span></div>
            <div class="value">
              {{element.app_version}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="driver_type">
          <th mat-header-cell *matHeaderCellDef style="width: 20%;">
            <div class="value">
              {{'DRIVERS.driverType' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">{{element.driver_type}}</td>
        </ng-container>
        <ng-container matColumnDef="vehicle_info">
          <th mat-header-cell *matHeaderCellDef>
            <div class="value">
              <!-- <input type="text" [placeholder]="" [(ngModel)]="filters.mobile" (keyup)="searchFilter(filters.mobile, 'mobile')">
                          <i class="material-icons clearIcon" *ngIf="filters.mobile" (click)="filters.mobile = ''; clearFilter('mobile');"> clear </i> -->
              {{'DRIVERS.vehicle_no' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="value">
              {{element.vehicle_name}}
            </div>
            <div class="value">
              {{element.vehicle_no}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="battery_status">
          <th mat-header-cell *matHeaderCellDef>
            <div class="input">
              {{'DRIVERS.battery_status' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="value">
              {{element.battery_status}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="shipment_info">
          <th mat-header-cell *matHeaderCellDef>
            <div class="input">
              {{'DRIVERS.shipment_id' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="value" *ngIf="element.shipment_id">
              {{element.shipment_id}}
            </div>
            <div class="value" *ngIf="element.shipment_status">
              {{element.shipment_status}}
            </div>
            <div class="value" *ngIf="!element.shipment_status && !element.shipment_id">
              --
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="licence_number">
          <th mat-header-cell *matHeaderCellDef>
            <div class="value">
              {{'DRIVERS.licence_number' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="value">
              {{element.licence?.no || 'N/A'}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>{{'DRIVERS.action' | translate}}</th>
          <td mat-cell *matCellDef="let element" style="width: 100px;">
            <div class="buttons">
              <div class="button">
                <mat-select [placeholder]="'DRIVERS.action' | translate">
                  <mat-option (click)="openViewDriver(element);"> <img style="width: 16px;position: relative;top: 3px;"
                      src="assets/View.svg" alt=""> {{'DRIVERS.view' | translate}}</mat-option>

                  <mat-option *ngIf="!element.attached" (click)="openAddDriver('EDIT', element);"> <img
                      style="width: 16px;position: relative;top: 3px;" src="assets/icon-edit.svg" alt="">
                    {{'DRIVERS.edit' | translate}}</mat-option>
                  <mat-option (click)="markOffDuty(element);">
                    <span *ngIf="element.driver_status">
                      <img style="width: 16px;position: relative;top: 3px;" src="assets/1_Off Duty.svg" alt="">
                      {{'DRIVERS.mark_off_duty' | translate}}
                    </span>
                    <span *ngIf="!element.driver_status">
                      <img style="width: 16px;position: relative;top: 3px;" src="assets/1_On Duty.svg" alt="">
                      {{'DRIVERS.mark_on_duty' | translate}}
                    </span>
                  </mat-option>
                  <!-- <mat-option>Block</mat-option> -->
                  <mat-option *ngIf="element.attached" (click)="openAttachVehicle(element, 'Detach');"> <img
                      style="width: 16px;position: relative;top: 3px;" src="assets/detach-driver.svg" alt="">
                    {{'DRIVERS.detach' | translate}}</mat-option>
                  <mat-option *ngIf="!element.attached" (click)="openAttachVehicle(element, 'Attach');"> <img
                      style="width: 16px;position: relative;top: 3px;" src="assets/atach-driver.svg" alt="">
                    {{'DRIVERS.attach' | translate}}</mat-option>
                  <mat-option (click)="openDriverPath(element);"> <img style="width: 16px;position: relative;top: 3px;"
                      src="assets/driver-path.svg" alt=""> {{'DRIVERS.driverPath' | translate}} </mat-option>
                  <mat-option *ngIf="!element.ws_opt_in" (click)="optInWa(element);"><img
                      style="width: 16px;position: relative;top: 3px;" src="assets/whatsappround.svg" alt="">
                    {{'DRIVERS.optIn' | translate}}</mat-option>
                  <mat-option (click)="addAttendanceDetails(element);"> <img
                      style="width: 16px;position: relative;top: 3px;" src="assets/icon-edit.svg" alt=""> Add Holidays &
                    Leave</mat-option>
                  <mat-option (click)="$event.stopPropagation(); openChangePwd(element);">
                    <i class="material-icons" style="width: auto;
                                    position: relative;
                                    top: 1px;
                                    font-size: 11px;
                                    border: solid 1px #104ab3;
                                    border-radius: 8px;
                                    padding: 1px;
                                    color: #104ab3;"> lock </i>
                    {{'DRIVERS.changePwd' | translate}}
                  </mat-option>
                  <mat-option (click)="$event.stopPropagation();openUploadDialog(element);"><img
                      style="width: 16px;position: relative;top: 3px;" src="assets/upload.svg" alt="">
                    {{'DRIVERS.upload' | translate}}</mat-option>

                </mat-select>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
      </table>
      <mat-paginator [length]="(driversList?.filteredData.length)? totalDrivers:0" [pageSize]="25"
        [pageSizeOptions]="[10, 15, 25, 50, 100]" showFirstLastButtons (page)="pageNavigate($event)"
        style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"></mat-paginator>

    </div>
    <ng-template #noDrivers>
      <div class="noDrivers">
        {{'DRIVERS.noDrivers' | translate}}
      </div>
      <!-- <div class="clearButton" *ngIf="filters.driver_type || filters.licence || filters.mobile || filters.name" >
            <div class="button" (click)="clear()">
              Clear
            </div>
          </div> -->
    </ng-template>
  </div>
</div>
<ng-template #optIn>
  <div class="dialogMain">
    <div class="section">
      <div class="header">
        <div class="label">
          {{'DRIVERS.optInForWa' | translate}}<i class="material-icons" (click)="optInRef.close();">clear</i>
        </div>
      </div>
      <div class="text">
        {{'DRIVERS.optInForWaText' | translate}}
      </div>
      <div class="submitButton">
        <div class="button" (click)="whatsapp();">
          Ok
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #smartPhone>
  <div class="dialogMain">
    <div class="section">
      <div class="header">
        <div class="label">
          {{'DRIVERS.smartphoneHeader' | translate}}<i class="material-icons" (click)="smartphoneRef.close();">clear</i>
        </div>
      </div>
      <div class="text">
        {{'DRIVERS.smartphoneText' | translate}}
      </div>
      <div class="submitButtonRight">
        <div class="button" (click)="markSelected(true);">
          {{'DRIVERS.haveSmartpone' | translate}}
        </div>
      </div>
      <div class="submitButtonLeft">
        <div class="button" (click)="markSelected(false);">
          {{'DRIVERS.dontHaveSmartpone' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #changePwd>
  <div class="dialogMain">
    <div class="section">
      <div class="header">
        <div class="label">
          {{'DRIVERS.changePwd' | translate}}<i class="material-icons" (click)="changePwdRef.close();">clear</i>
        </div>
      </div>
      <div class="text">
        {{'DRIVERS.driverName' | translate}} : {{selectedDriver.driverName}}
      </div>
      <div class="body">
        <div class="formElement">
          <div class="formLabel">
            {{'ADDDRIVER.password' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
          </div>
          <div class="formInput">
            <input class="form-input" autocomplete="off" name="newPAssword" id="newPassword"
              [(ngModel)]="selectedDriver.newPassword" type="password" />
          </div>
        </div>

        <div class="formElement">
          <div class="formLabel">
            {{'ADDDRIVER.confirm' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
          </div>
          <div class="formInput">
            <input class="form-input" autocomplete="off" name="newConfirmPassword" id="newConfirmPassword"
              [(ngModel)]="selectedDriver.confirmPassword" type="password" />
          </div>
        </div>
      </div>
      <div class="submitButton">
        <div class="button" (click)="(!disableButton) ? changePassword() : '';">
          {{'ADDDRIVER.submit' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #markOnOff>
  <div class="dialogMain">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <div class="label">
          {{dialogData.name}}<i class="material-icons" (click)="closeModal();">clear</i>
        </div>
      </div>
      <!-- <div class="text">
        {{dialogData.text}}
      </div> -->
      <div class="body">
        <div class="formElement_mark" *ngIf="dialogData.markOff">
          <div class="formLabel">
            {{'DRIVERS.leave_type' | translate}}<sup style="color: #E54131; font-weight: 900;">*</sup>
          </div>
          <div class="inputSelect">
            <mat-select [(ngModel)]="selectedLeaveType">
              <mat-option *ngFor="let type of leave_types" [value]="type" (click)="selectLeaveType(type)">
                {{type.name}}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="formElement_mark">
          <div class="formLabel">
            {{'DRIVERS.comment' | translate}}<sup *ngIf="dialogData.markOff"
              style="color: #E54131; font-weight: 900;">*</sup>
          </div>
          <div class="formInput">
            <input class="form-input" autocomplete="off" [(ngModel)]="dialogData.comment" type="text" />
          </div>
        </div>
      </div>
      <div class="submitButton">
        <div class="button" (click)="submitMarkOnOff()">
          {{'ADDDRIVER.submit' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #uploadDialog>
  <div class="dialogMain">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <div class="label">
          {{'DRIVERS.upload' | translate}}<i class="material-icons" (click)="uploadDocsRef.close();">clear</i>
        </div>
      </div>
      <div class="uploadFile">
        <input class="inputField" (change)="fileChanged($event)" type="file" accept="image/*">
      </div>
      <div class="imageTypes">
        (Only .png, .jpeg or JPG files)
      </div>
      <div class="submitButton">
        <div class="button" (click)="uploadRegDocs();">
          {{'DRIVERS.submit' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #MultipleVideoOptions>
  <div class="MultiplevideoMain">
    <!-- <div class="header">
      <div class="label">
        {{'DRIVERS.adding_ownfleet_driver' | translate}}
      </div>
      
    </div> -->
    <div class="body">
      <div class="close">
        <span class="material-icons" (click)="MultipleVideoLinkRef.close()" style="cursor: pointer;float: right;">
          close
        </span>
      </div>
      <div>

        <div class="adding_sec1" (click)="openOwnFleetDriverLink()">
          <span class="arrow_video">
            <img alt="" src="assets/helpicon.svg" style="width: 17px;margin-top: 3px;">
          </span>
          <span class="text_video">{{'DRIVERS.adding_ownfleet_driver' | translate}}</span>
        </div>
        <!-- <div class="adding_sec" (click)="openSpotDriverVideoLink()">
          <span class="arrow_video">
            <img alt="" src="assets/helpicon.svg" style="width: 17px;margin-top: 3px;">
          </span>
          <span class="text_video">{{'DRIVERS.adding_spot_driver' | translate}}</span>
        </div> -->
        <div class="adding_sec" (click)="attachVehicleToDriverVideoLink()">
          <span class="arrow_video">
            <img alt="" src="assets/helpicon.svg" style="width: 17px;margin-top: 3px;">
          </span>
          <span class="text_video">{{'DRIVERS.Attach_vehicle_driver' | translate}}</span>
        </div>

        <div class="adding_sec" (click)="detachVehicleVideoLink()">
          <span class="arrow_video">
            <img alt="" src="assets/helpicon.svg" style="width: 17px;margin-top: 3px;">
          </span>
          <span class="text_video">{{'DRIVERS.Detach_vehicle' | translate}}</span>
        </div>

      </div>
    </div>
  </div>

</ng-template>

<ng-template #ownFleetDriver>


  <div class="uploadDialogMain">
    <div class="header">
      <div class="label">
        {{'DRIVERS.adding_ownfleet_driver' | translate}}
      </div>
      <div class="close">
        <span class="material-icons" (click)="VideoLinkRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div class="body">
      <div>
        <div style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          border-radius: 0;
          box-shadow: 0 15px 40px rgba(63,58,79,.3);
          overflow: hidden;
          min-width:320px"><iframe [src]="video_URL_OWN_FLEET" frameborder="0" webkitallowfullscreen mozallowfullscreen
            allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
      </div>
    </div>
  </div>

</ng-template>



<!-- <ng-template #SpotDriver>


  <div class="uploadDialogMain">
    <div class="header">
      <div class="label">
        {{'DRIVERS.adding_spot_driver' | translate}}
      </div>
      <div class="close">
        <span class="material-icons" (click)="VideoLinkRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div class="body">
      <div>
        <div style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          border-radius: 0;
          box-shadow: 0 15px 40px rgba(63,58,79,.3);
          overflow: hidden;
          min-width:320px"><iframe [src]="video_URL_Spot" frameborder="0" webkitallowfullscreen mozallowfullscreen
            allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
      </div>
    </div>
  </div>

</ng-template> -->

<ng-template #attachVehicleToDriver>


  <div class="uploadDialogMain">
    <div class="header">
      <div class="label">
        {{'DRIVERS.Attach_vehicle_driver' | translate}}
      </div>
      <div class="close">
        <span class="material-icons" (click)="VideoLinkRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div class="body">
      <div>
        <div style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          border-radius: 0;
          box-shadow: 0 15px 40px rgba(63,58,79,.3);
          overflow: hidden;
          min-width:320px"><iframe [src]="video_ATTACH_VEHICLE_DRIVER" frameborder="0" webkitallowfullscreen
            mozallowfullscreen allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #detachVehicle>


  <div class="uploadDialogMain">
    <div class="header">
      <div class="label">
        {{'DRIVERS.Detach_vehicle' | translate}}
      </div>
      <div class="close">
        <span class="material-icons" (click)="VideoLinkRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div class="body">
      <div>
        <div style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          border-radius: 0;
          box-shadow: 0 15px 40px rgba(63,58,79,.3);
          overflow: hidden;
          min-width:320px"><iframe [src]="video_DETACH_VEHICLE" frameborder="0" webkitallowfullscreen
            mozallowfullscreen allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
      </div>
    </div>
  </div>

</ng-template>